import React, { useRef, useEffect, useState } from 'react';
import CustomHook from './CustomHook';
import '../styles/Home.css';

const nameVariants = [
  { name: 'Shreyas', language: 'English' },
  { name: 'ಶ್ರೇಯಸ್', language: 'Kannada' },
  { name: 'श्रेयस', language: 'Sanskrit' },
  { name: 'శ్రేయస్', language: 'Telugu' },
  { name: 'ശ്രേയസ്', language: 'Malayalam' },
  { name: 'শ্রেয়স', language: 'Bengali' },
  { name: 'シュレーヤス', language: 'Japanese' },
  { name: 'ஷ்ரேயஸ்', language: 'Tamil' },
  { name: 'શ્રેયસ', language: 'Gujarati' },
  { name: 'ਸ਼੍ਰੇਅਸ', language: 'Punjabi' },
  { name: 'ଶ୍ରେୟସ', language: 'Odia' },
  { name: 'শ্ৰেয়াস', language: 'Assamese' },
  { name: '슈레야스', language: 'Korean' },
  { name: 'ชเรยัส', language: 'Thai' },
  { name: 'သျှရိယပ်စ်', language: 'Burmese' },
  // { name: 'شرياس', language: 'Arabic' },
  { name: 'שריאס', language: 'Hebrew' },
  // { name: '什雷亚斯', language: 'Chinese (Simplified)' },
  { name: '什雷亞斯', language: 'Chinese (Traditional)' },
  { name: 'Шрейас', language: 'Russian/Ukrainian' },
  { name: 'Σρέυας', language: 'Greek' },
  { name: 'Szrejas', language: 'Polish' },
  { name: 'Şreyas', language: 'Turkish' },
  { name: 'Sréjas', language: 'Hungarian' },
  { name: 'Шреяс', language: 'Bulgarian' },
  { name: 'Šrėjas', language: 'Lithuanian' },
  { name: 'Šrējas', language: 'Latvian' },
  { name: 'ሽሬያስ', language: 'Amharic' },
];

function Home() {
  const refTab = useRef();
  const desRef = useRef();
  const [, setDesHeight] = useState(0);
  // const englishObj = nameVariants.find(v => v.language === 'English');

  CustomHook(refTab);

  useEffect(() => {
    if (desRef.current) {
      const height = desRef.current.offsetHeight;
      setDesHeight(height);
      desRef.current.style.setProperty('--des-height', `${height}px`);
    }
  }, []);

  // Typing effect state
  const TYPING_EFFECT_ENABLED = true;
  const [displayed, setDisplayed] = useState(TYPING_EFFECT_ENABLED ? '' : 'Shreyas');
  const [nameIdx, setNameIdx] = useState(0);
  const [charIdx, setCharIdx] = useState(0);
  const [isErasing, setIsErasing] = useState(false);

  // Pause state for click-to-English
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    if (!TYPING_EFFECT_ENABLED || paused) return;
    const currentName = nameVariants[nameIdx].name;
    let timeout;
    if (!isErasing && charIdx < currentName.length) {
      timeout = setTimeout(() => {
        setDisplayed(currentName.slice(0, charIdx + 1));
        setCharIdx(charIdx + 1);
      }, 120);
    } else if (!isErasing && charIdx === currentName.length) {
      timeout = setTimeout(() => setIsErasing(true), 1200);
    } else if (isErasing && charIdx > 0) {
      timeout = setTimeout(() => {
        setDisplayed(currentName.slice(0, charIdx - 1));
        setCharIdx(charIdx - 1);
      }, 60);
    } else if (isErasing && charIdx === 0) {
      timeout = setTimeout(() => {
        setIsErasing(false);
        setNameIdx((nameIdx + 1) % nameVariants.length);
      }, 400);
    }
    return () => clearTimeout(timeout);
  }, [charIdx, isErasing, nameIdx, TYPING_EFFECT_ENABLED, paused]);

  // Click handler to pause/resume and show English
  const handleNameClick = () => {
    if (!paused) {
      setPaused(true);
      setDisplayed('Shreyas');
    } else {
      setPaused(false);
      setCharIdx(0);
      setIsErasing(false);
      setNameIdx(0);
    }
  };

  return (
    <section ref={refTab} className="home">
      <div className="content">
        <div className="name">
          Hey, I'm{' '}
          <span
            className="typing-name"
            onClick={handleNameClick}
            style={{ cursor: 'pointer', position: 'relative' }}
            title={paused ? "English" : (nameVariants[nameIdx].language || "English")}
          >
            {displayed}
          </span>
          <br />
          <div className="role">I am a Developer.</div>
        </div>
        <div className="button">
          <a
            href="assets/Shreyas_Resume.html"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="A link pointing to my resume"
          >
            Download My CV
          </a>
        </div>
        <div className="des" ref={desRef}>
          Ahoy! <br />
          {/* Software engineer with an interest in building systems that combine graphics, AI, and simulation. Currently focused on real-time graphics, procedural simulation, and interpretable neural networks. Previous experience as a backend developer working on automation using Python, Shell scripting, SQL, and PL/SQL in the supply chain industry. */}
          {/* Software engineer exploring the intersection of graphics, AI, and simulation. Focused on real-time rendering, procedural simulation, and interpretable neural networks, with prior experience in backend automation for supply chain systems. */}
          Software engineer at Medtronic, building medical device software and diagnostics. Experienced with real-time systems, simulation, and ML, with prior work in supply chain automation.
        </div>
      </div>
      <div className="avatar">
        <div className="card">
          <img src="/AnimatedPotrate.png" alt="My Avatar" />
          <div className="info">
            {/* <div>Engineer</div>
            <div>India</div> */}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Home;